import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../services/api/api-options.config';
import { ItemTypesService } from '../../../../services/api/general-settings/item-types.service';
import { RouteService } from '../../../../services/route.service';
import { BaseIndexPageComponent } from "../../../../components/pages/base-index-page/base-index-page.component";

@Component({
  selector: 'app-item-types-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './item-types-index-page.component.html',
  styleUrl: './item-types-index-page.component.scss'
})
export class ItemTypesIndexPageComponent {
list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected itemTypesService: ItemTypesService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Item Types',
      cardTitle: 'Manage Item Types',
      addNewItemButton: {
        type: 'success',
        title: 'Add Item Type',
        onClick: () => {
          this.routeService.itemTypesCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),          
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View itemType details',
                onClick: (item: any) => {
                  this.routeService.itemTypesDetail(item.itemTypeId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit itemType',
                onClick: (item: any) => {
                  this.routeService.itemTypesUpdate(item.itemTypeId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete itemType',
                onClick: (item: any) => {                  
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((itemTypes: any) => itemTypes.itemTypeId !== item.itemTypeId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.itemTypesService.list(options),
      responseListModelName: 'itemTypes',
    }
  }
}
